import { NewTable } from '../../../comps/NewTable'
import { getCustomColumnWidth, useWindowDimensions } from '../../../util/util'

interface TableViewProps {
  users: any
  show: boolean
}

const TableView = ({ users, show }: TableViewProps) => {
  const viewPortWidth = useWindowDimensions()
  //console.log('users', users)
  if (!show) {
    return null
  }
  return (
    <NewTable
      data={users.slice(1)}
      rowHeight={48}
      headerHeight={64}
      customWidthFunc={getCustomColumnWidth}
      onRowClick={() => null}
      tableWidth={viewPortWidth > 1200 ? viewPortWidth - 280 : viewPortWidth}
      headerRowKeys={users[0]}
    />
  )
}

export { TableView }
